import { useTranslation } from 'react-i18next';
import { CampaignSocialMediaType } from '@anytag/graphql';
import { getSocialMediaTextLink } from '@anytag/shared-utils';
import { Icon, Anchor, Button, TextCutter, SocialIcon, MediaPreview, SocialIconProps } from '@anytag/shared-atoms';

interface PostProps {
  url: string;
  content: string;
  isEngagement?: boolean;
  onClickPost: () => void;
  thumbNail: string | null;
  hasTrafficSource: boolean | null;
  socialMedia: CampaignSocialMediaType;
}

export const Post = ({
  url,
  content,
  thumbNail,
  socialMedia,
  onClickPost,
  isEngagement,
  hasTrafficSource
}: PostProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-6 items-center gap-2">
      <MediaPreview
        objectFit="contain"
        onClick={onClickPost}
        className="size-10 rounded-sm"
        src={thumbNail}
        caption={content}
        captionProps={{ margin: 4 }}
      />
      <div className="flex min-w-25 justify-between gap-2">
        <div>
          <TextCutter
            lines={2}
            onClick={onClickPost}
            text={content || '-'}
            className="cursor-pointer text-sm leading-3"
          />
          {url ? (
            <Anchor href={url} target="_blank" variant="blue" className="mt-1 flex items-center text-sm">
              <SocialIcon size="16px" type={socialMedia as SocialIconProps['type']} css={{ marginRight: '4px' }} />
              {t('View on', { socialMedia: getSocialMediaTextLink(socialMedia) })}
            </Anchor>
          ) : null}
        </div>
        {isEngagement && socialMedia === CampaignSocialMediaType.YOUTUBE && hasTrafficSource ? (
          <Button
            onClick={onClickPost}
            title={<Icon icon="bar-chart" size={12} variant="inherit" />}
            tooltip={{ content: t<string>('Traffic Source') }}
            className="h-6 min-w-6 self-center p-0"
          />
        ) : null}
      </div>
    </div>
  );
};
